import { SaveOutlined } from "@ant-design/icons";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Input,
  message,
  Row,
  Typography,
} from "antd";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
  DefaultErrorMessage,
  IsActive,
  SessionLength,
  UpdateDataSuccessfully,
} from "shared/constants/define-localization";
import { CoreResource, t } from "shared/plugins/localization";
import { setLoading } from "states/global-value/global-value.slice";
import {
  getBranchOrderPickupSetting,
  updateBranchOrderPickupSetting,
} from "states/branch-order-pickup-setting/branch-order-pickup-setting.api";
import { OrderPickupSettingModel } from "shared/models/order-pickup-setting-model";

export interface IBranchOrderPickupTabProps {
  branchId: number;
}

export function BranchOrderPickupTab(props: IBranchOrderPickupTabProps) {
  const [model, setModel] = useState<OrderPickupSettingModel>(
    {} as OrderPickupSettingModel
  );
  const dispatch = useDispatch();
  const _handleSaveSetting = async () => {
    if (!props.branchId) return;
    dispatch(setLoading(true));
    try {
      await updateBranchOrderPickupSetting(props.branchId, model);
      dispatch(setLoading(false));
      message.success("Cập nhật thành công");
    } catch (error) {
      dispatch(setLoading(false));
      message.error(
        error?.response?.data?.error?.message ??
          "Lỗi hệ thống"
      );
    }
  };

  useEffect(() => {
    if (props.branchId) {
      getBranchOrderPickupSetting(props.branchId).then((res) => {
        setModel(res.data);
      });
    }
  }, [props.branchId]);

  return (
    <div>
      <Row gutter={[16, 16]} className="mb-4">
        <Col flex="auto">
          <Button onClick={_handleSaveSetting} icon={<SaveOutlined />}>
            Save Setting
          </Button>
        </Col>
      </Row>
      <Row gutter={[16, 16]} justify="space-between">
        <Col span={24}>
          <Card title="Order Pickup Setting" bordered={false}>
            <Input.Group className="mb-4">
              <Typography.Text>
                {t(CoreResource, SessionLength)}
              </Typography.Text>
              <Input
                type="number"
                value={model.sessionLength}
                onChange={(e) => {
                  setModel({
                    ...model,
                    sessionLength: e.target.valueAsNumber,
                  });
                }}
                placeholder={t(CoreResource, SessionLength)}
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Typography.Text>Max orders per session</Typography.Text>
              <Input
                type="number"
                value={model.maxOrderPerSession}
                onChange={(e) => {
                  setModel({
                    ...model,
                    maxOrderPerSession: e.target.valueAsNumber,
                  });
                }}
                placeholder="Max orders per session"
              ></Input>
            </Input.Group>
            <Input.Group className="mb-4">
              <Checkbox
                checked={model.isActive}
                onChange={(e) => {
                  setModel({ ...model, isActive: e.target.checked });
                }}
              >
                {t(CoreResource, IsActive)}
              </Checkbox>
            </Input.Group>
          </Card>
        </Col>
      </Row>
    </div>
  );
}
